import { AfterViewInit, Component, Inject, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { CookieService } from 'ngx-cookie';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { environment } from '@env/environment';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit{
  showLoader = false;

  constructor(
    private translate: TranslateService,
    private localize: LocalizeRouterService,
    private cookie: CookieService,
    private router: Router,
    private title: Title,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {
    this.setLanguage();
    this.setTitle();
    this.renderer.addClass(document.body, `${environment.theme}-theme`);
  }

  private setLanguage(): void {
    const route = this.router.url;
    const langPrefix = this.localize.parser.getLocationLang(route) || this.translate.getDefaultLang();
    this.cookie.put('dWLang', langPrefix);
    // const lang = this.cookie.get('dWLang') || langPrefix
    this.translate.setDefaultLang(langPrefix);
    this.translate.use(langPrefix);
    this.localize.changeLanguage(langPrefix, {replaceUrl: false});
  }

  ngAfterViewInit(): void {
    this.router.events.subscribe((routerEvent) => {
      if (routerEvent instanceof NavigationStart) {
        setTimeout(() => { this.showLoader = true; }, 0);
      }

      if (routerEvent instanceof NavigationEnd ||
          routerEvent instanceof NavigationCancel ||
          routerEvent instanceof NavigationError) {
        setTimeout(() => { this.showLoader = false; }, 0);
      }
    });
  }

  private setTitle(): void {
    if (environment.theme !== 'default') {
      const title = environment.theme[0].toUpperCase() + environment.theme.slice(1);
      this.title.setTitle(title);
    }
  }
}
